import React from 'react';
import PropTypes from 'prop-types';

class SearchBarResults extends React.Component {
  constructor(props) {
    super(props);

    this.renderResults = this.renderResults.bind(this);
  }

  renderResults(result, index, array) {
  	if (!this.props.maxShow || index <= this.props.maxShow) {
	  	return (
	  		<div
	  			key={index}
	  			className={this.props.customListItemClass}>
	  			<li onClick={this.props.onSelect ? this.props.onSelect.bind(null, index) : null}>
			  		{this.props.display(result)}
		  		</li>
		  	</div>
  		);
	  }
  }

  render() {
    return (
      <div className={this.props.customResultsListClass || 'search-bar-results-list-container'}>
  			<ul>{this.props.options ? this.props.options.map(this.renderResults) : ''}</ul>
      </div>
    );
  }
}

export default SearchBarResults;



// WEBPACK FOOTER //
// ./src/browser/components/ui/searchBar/searchBarResultsList.js